var map = {
	"./m/screenshot1.png": 406,
	"./m/screenshot2.png": 407,
	"./m/screenshot3.png": 408,
	"./m/screenshot4.png": 409,
	"./m/screenshot5.png": 410,
	"./m/screenshot6.png": 411,
	"./m/screenshot7.png": 412,
	"./m/winterwizardjam.png": 413,
	"./o/screenshot1.png": 414,
	"./o/screenshot2.png": 415,
	"./o/screenshot3.png": 416,
	"./o/screenshot4.png": 417,
	"./o/screenshot5.png": 418,
	"./o/screenshot6.png": 419,
	"./o/screenshot7.png": 420,
	"./o/winterwizardjam.png": 421,
	"./s/winterwizardjam.png": 422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;